import PropTypes from 'prop-types';

import RichText, { fragment } from '../../Core/RichText';
import Link from '../../Core/Link';

import { Section, Grid } from './styles';

const JumpLinks = ({ data }) => {
  if (!data) return null;
  const { backgroundColor, contentAlignment, ctas } = data;
  return (
    <Section
      backgroundColor={backgroundColor}
      contentAlignment={contentAlignment}
      className={backgroundColor}
      id="jump-links"
    >
      <Grid>
        {ctas &&
          ctas.map(cta => {
            if (cta.hideFrench === true) return null;
            return (
              <Link key={cta.id} data={cta}>
                <RichText document={cta.label} options={fragment} />
              </Link>
            );
          })}
      </Grid>
    </Section>
  );
};

JumpLinks.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default JumpLinks;
